// extracted by mini-css-extract-plugin
module.exports = {"c-footer":"_84ff5fbbc9--c-footer--s8IHi","c-footer-mobile":"_84ff5fbbc9--c-footer-mobile--sjZIZ","c-footer-adaptive":"_84ff5fbbc9--c-footer-adaptive--OL3pj"};